<!--suppress BuyFluidPluginNoteInspection -->
<div class="row">
  <div class="col col-lg-7">
    <div *ngIf="!isNew()" class="container">
      <h3 class="card-subtitle mb-2 text-muted text-black fw-bold">Job Details</h3>
      <hr style="margin: 0px !important;"/>
      <br/>
    </div>

    <div class="container">
      <div *ngIf="employment">

        <div class="row style-row-gap-10" *ngIf="isNew()">
          <div class="col col-lg-12">
            <mat-form-field style="width: 100%">
              <mat-label>Location</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.location" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let location of masterEntities.locations | async | sortByName"
                            [value]="location">{{location.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Employee Status</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.employeeStatus" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let employeeStatus of masterEntities.employeeStatuses | async"
                            [value]="employeeStatus">{{employeeStatus.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Employee Type</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.employeeType" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let employeeType of masterEntities.employeeTypes | async"
                            [value]="employeeType">{{employeeType.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-12">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Status change reason</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.statusChangeReason">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Hire Date</mat-label>
              <input [disabled]="true" matInput [formControl]="hiredOn" [matDatepicker]="hireDate">
              <mat-datepicker-toggle *ngIf="hiredOn.value != null" matSuffix (click)="hiredOn.setValue(null)">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker-toggle matSuffix [for]="hireDate"></mat-datepicker-toggle>
              <mat-datepicker #hireDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Eligible for rehire</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.eligibleForRehire">
                <mat-option [value]=""></mat-option>
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Effective Date</mat-label>
              <input [disabled]="true" matInput [formControl]="effectiveOn" [matDatepicker]="effectiveOnId">
              <mat-datepicker-toggle *ngIf="effectiveOn.value != null" matSuffix (click)="effectiveOn.setValue(null);">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker-toggle matSuffix [for]="effectiveOnId"></mat-datepicker-toggle>
              <mat-datepicker #effectiveOnId></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Termination Date</mat-label>
              <input [disabled]="true" matInput [formControl]="terminatedOn" [matDatepicker]="terminatedOnId">
              <mat-datepicker-toggle *ngIf="terminatedOn.value != null" matSuffix
                                     (click)="terminatedOn.setValue(null);">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker-toggle matSuffix [for]="terminatedOnId"></mat-datepicker-toggle>
              <mat-datepicker #terminatedOnId></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-12">
            <mat-form-field style="width: 100%">
              <mat-label>Job Title</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.jobTitle" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let jobTitle of masterEntities.jobTitles | async"
                            [value]="jobTitle">{{jobTitle.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Department</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.department" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let department of masterEntities.departments | async"
                            [value]="department">{{department.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Position</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.position" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let position of masterEntities.positions | async"
                            [value]="position">{{position.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-12">
            <mat-form-field style="width: 100%">
              <mat-label>Manager</mat-label>
              <mat-select [disabled]="true" id="manager" name="manager" [(ngModel)]="employment.manager"
                          [compareWith]="compareOption">
                <mat-option [value]="employment.manager">
                  {{(employment.manager?.firstName || '') + ' ' + (employment.manager?.lastName || '') }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Work Phone</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.workAddress.workPhone">
            </mat-form-field>
          </div>

          <div class="col col-lg-2">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Extension</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.workAddress.workPhoneExtension">
            </mat-form-field>
          </div>

          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Work Email</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.workAddress.workEmail">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Benefit Class</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.benefitClass" [disabled]="true">
            </mat-form-field>
          </div>

          <div class="col col-lg-6 padding-top-12">
            <mat-form-field style="width: 100%">
              <mat-label>Benefit Class Effective Date</mat-label>
              <input [disabled]="true" matInput [formControl]="benefitClassEffectiveDate"
                     [matDatepicker]="effectiveDateId" disabled>
              <mat-datepicker-toggle *ngIf="benefitClassEffectiveDate.value != null" matSuffix
                                     (click)="benefitClassEffectiveDate.setValue(null)"
                                     [disabled]="true">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker-toggle matSuffix [for]="effectiveDateId" [disabled]="true"></mat-datepicker-toggle>
              <mat-datepicker #effectiveDateId></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <br/><br/>
        <h3 class="card-subtitle mb-2 text-muted text-black fw-bold">Salary</h3>
        <hr style="margin: 0px !important;"/>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Pay Rate</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.payRate.payRate">
            </mat-form-field>
          </div>

          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Rate Per</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.payRate.ratePer">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Pay Type</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.payRate.payType" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let payType of masterEntities.payTypes | async"
                            [value]="payType">{{payType.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Pay Frequency</mat-label>
              <mat-select [disabled]="true" [(ngModel)]="employment.payRate.payFrequency" [compareWith]="compareOption">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let payFrequency of masterEntities.payFrequencies | async"
                            [value]="payFrequency">{{payFrequency.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Annual Salary</mat-label>
              <input [disabled]="true" matInput [(ngModel)]="employment.payRate.annualSalary">
            </mat-form-field>
          </div>

          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Effective Date</mat-label>
              <input [disabled]="true" matInput [formControl]="payRateEffectiveDate"
                     [matDatepicker]="payRateEffectiveDate">
              <mat-datepicker-toggle *ngIf="payRateEffectiveDate.value != null" matSuffix>
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker-toggle matSuffix [for]="payRateEffectiveDateId"></mat-datepicker-toggle>
              <mat-datepicker #payRateEffectiveDateId></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <br/><br/>
        <h3 class="card-subtitle mb-2 text-muted text-black fw-bold">ProSal
          <mat-slide-toggle [(ngModel)]="employment.prosalInfo.active"
                            (ngModelChange)="onProsalChange(employment)"></mat-slide-toggle>
        </h3>
        <hr style="margin: 0px !important;"/>
        <br/>
        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Effective Date</mat-label>
              <input [disabled]="!employment.prosalInfo.active" matInput [formControl]="prosalEffectiveDate"
                     [matDatepicker]="prosalEffectiveOnId" (dateChange)="onProsalEffectiveDateChange($event)">
              <mat-datepicker-toggle *ngIf="prosalEffectiveDate.value != null" matSuffix
                                     (click)="clearProsalEffectiveDate()">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker-toggle matSuffix [for]="prosalEffectiveOnId"></mat-datepicker-toggle>
              <mat-datepicker #prosalEffectiveOnId></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>End Date</mat-label>
              <input [disabled]="!employment.prosalInfo.active" matInput [formControl]="prosalEndDate"
                     [matDatepicker]="prosalEndOnId" (dateChange)="onProsalEndDateChange($event)">
              <mat-datepicker-toggle *ngIf="prosalEndDate.value != null" matSuffix (click)="clearProsalEndDate()">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker-toggle matSuffix [for]="prosalEndOnId"></mat-datepicker-toggle>
              <mat-datepicker #prosalEndOnId></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Practice Type</mat-label>
              <mat-select [(ngModel)]="employment.prosalInfo.practiceType" [disabled]="!employment.prosalInfo.active"
                          (selectionChange)="onPracticeTypeChange($event)">
                <mat-option value=""></mat-option>
                <mat-option value="GP">GP</mat-option>
                <mat-option value="Spec">Spec</mat-option>
                <mat-option value="PetMedc UC">PetMedc UC</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-4">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Service Percent</mat-label>
              <input [disabled]="!employment.prosalInfo.active || employment.prosalInfo.servicePercentDynamic" matInput
                     pattern="^(100(\.0+)?|[0-9]{1,2}(\.[0-9]+)?)$"
                     [(ngModel)]="employment.prosalInfo.servicePercent" (change)="onServicePercentChange($event)">
              <mat-hint>Enter a single number</mat-hint>
            </mat-form-field>
            <div *ngIf="servicePercentErrorMessage" class="custom-alert-box" style="color: red; margin-top: 10px;">
              {{ servicePercentErrorMessage }}
            </div>
          </div>
          <div class="col col-lg-2">
            <mat-checkbox style="padding-top: 20px" [(ngModel)]="employment.prosalInfo.servicePercentDynamic"
                          [disabled]="!employment.prosalInfo.active"
                          (change)="onServicePercentDynamicChange($event)"
                          matTooltip="Dynamic service percent: {{SERVICE_PERCENT_DYNAMIC_VALUE}} based on revenue amount"
                          matTooltipPosition="above">
              Dynamic
            </mat-checkbox>
          </div>

          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Product Percent</mat-label>
              <input [disabled]="!employment.prosalInfo.active" matInput
                     pattern="^(100(\.0+)?|[0-9]{1,2}(\.[0-9]+)?)$"
                     [(ngModel)]="employment.prosalInfo.productPercent" (change)="onProductPercentChange($event)">
              <mat-hint>Enter a single number</mat-hint>
            </mat-form-field>
            <div *ngIf="productPercentErrorMessage" class="custom-alert-box" style="color: red; margin-top: 10px;">
              {{ productPercentErrorMessage }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Service Exclusions</mat-label>
              <mat-select [formControl]="serviceExclusions" multiple [disabled]="!employment.prosalInfo.active"
                          (selectionChange)="onServiceExclusionsChange($event)">
                <mat-option
                  *ngFor="let account of masterEntities.aahaAccounts | async | aahaAccountRevenueCategory : 'SERVICE'"
                  [value]="account.id">{{account.code}} - {{account.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col col-lg-6">
            <mat-form-field style="width: 100%">
              <mat-label>Product Exclusions</mat-label>
              <mat-select [formControl]="productExclusions" multiple [disabled]="!employment.prosalInfo.active"
                          (selectionChange)="onProductExclusionsChange($event)">
                <mat-option
                  *ngFor="let account of masterEntities.aahaAccounts | async | aahaAccountRevenueCategory : 'PRODUCT'"
                  [value]="account.id">{{account.code}} - {{account.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Digital Imaging Commission</mat-label>
              <input [disabled]="!employment.prosalInfo.active" matInput
                     [(ngModel)]="employment.prosalInfo.diCommission" (change)="onDiCommissionChange($event)">
            </mat-form-field>
          </div>

          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Frequency</mat-label>
              <input [disabled]="!employment.prosalInfo.active" matInput [(ngModel)]="employment.prosalInfo.frequency"
                     (change)="onProsalFrequencyChange($event)">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-6">
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-label>Annual Salary</mat-label>
              <input [disabled]="!employment.prosalInfo.active" matInput
                     pattern="^(0|[1-9][0-9]+)(\.[0-9]{2})?$"
                     [(ngModel)]="employment.prosalInfo.annualSalary" (change)="onProsalAnnualSalaryChange($event)">
              <mat-hint>If entered, it will override employment annual salary for ProSal calculation.</mat-hint>
            </mat-form-field>
            <div *ngIf="prosalAnnualSalaryErrorMessage" class="custom-alert-box" style="color: red; margin-top: 10px;">
              {{ prosalAnnualSalaryErrorMessage }}
            </div>
          </div>

          <div class="col col-lg-6">
            <mat-checkbox style="padding-top: 20px" [checked]="employment.prosalInfo.excludeSalary"
                          [disabled]="!employment.prosalInfo.active"
                          (change)="onExcludeSalaryChange($event)">
              Exclude Salary
            </mat-checkbox>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="col col-lg-4 offset-lg-1 padding-top-15" *ngIf="employment" [hidden]="!authService.isAdmin() || isNew()">
    <app-employment-sync-widget [employmentId]="employment.id"></app-employment-sync-widget>
  </div>
</div>
